import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_ADMIN_API_URL || 'http://localhost:6005/api';

// Create axios instance
export const adminApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

// Add request interceptor to include auth token
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Remove invalid token and redirect to login
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authApi = {
  login: async (email: string, password: string) => {
    const response = await adminApi.post('/auth/login', { email, password });
    return response.data;
  },
  
  verify: async () => {
    const response = await adminApi.get('/auth/verify');
    return response.data;
  },
  
  logout: async () => {
    const response = await adminApi.post('/auth/logout');
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    return response.data;
  }
};

// Analytics API
export const analyticsApi = {
  getDashboard: async (filters?: { session_type?: string; purpose?: string }) => {
    const params = new URLSearchParams();
    if (filters?.session_type) params.set('session_type', filters.session_type);
    if (filters?.purpose) params.set('purpose', filters.purpose);
    const query = params.toString();
    const response = await adminApi.get(`/analytics/dashboard${query ? `?${query}` : ''}`);
    return response.data;
  },
  
  getUsers: async (page = 1, limit = 20, filters?: { session_type?: string; purpose?: string }) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filters?.session_type) params.set('session_type', filters.session_type);
    if (filters?.purpose) params.set('purpose', filters.purpose);
    const response = await adminApi.get(`/analytics/users?${params.toString()}`);
    return response.data;
  },
  
  getUserSessions: async (email: string, page = 1, limit = 10, filters?: { session_type?: string; purpose?: string }) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filters?.session_type) params.set('session_type', filters.session_type);
    if (filters?.purpose) params.set('purpose', filters.purpose);
    const response = await adminApi.get(`/analytics/users/${encodeURIComponent(email)}/sessions?${params.toString()}`);
    return response.data;
  }
};